export default "__VITE_ASSET__29n2o$Ub__"